import { StatePersistence } from '@/utils/statePersistence'

const state = {
  cart: StatePersistence.getCart(),
}

const mutations = {
  addToCart(state, product) {
    state.cart.push(product)
    StatePersistence.saveCart(state.cart)
  },
  removeFromCart(state, productIndex) {
    state.cart.splice(productIndex, 1)
    StatePersistence.saveCart(state.cart)
  },

  UPDATE_CART_ENTRIES(state, payload) {
    state.cart = payload
    StatePersistence.saveCart(state.cart)
  },

  UPDATE_QUANTITY(state, payload) {
    const item = state.cart.find(item => item.id === payload.id)
    if (item) {
      item.qty = payload.qty
      StatePersistence.saveCart(state.cart)
    }
  },
}

const actions = {
  getCartEntries({ commit }) {
    const persistedCart = StatePersistence.getCart()
    commit('UPDATE_CART_ENTRIES', persistedCart)
  },
  addToCart({ commit }, product) {
    commit('addToCart', product)
  },
  removeFromCart({ commit }, productIndex) {
    commit('removeFromCart', productIndex)
  },
  updateProductQuantity({ commit }, { productId, quantity }) {
    commit('UPDATE_QUANTITY', { id: productId, qty: quantity })
  },
  cleanCart({ commit }) {
    commit('UPDATE_CART_ENTRIES', [])
  },
}

const getters = {
  cart(state) {
    return state.cart
  },
  cartItemCount(state) {
    return state.cart.length
  },
}

const cartModule = {
  state,
  mutations,
  actions,
  getters,
}

export default cartModule
